import styled, { keyframes } from 'styled-components'

// Shimmer animation for modern skeleton loading
const shimmer = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

export const PlaceholderContainer = styled.div`
  display:flex;
  border: 1px solid #eaecef;
  height: 100%;
  padding: 1%;
  background-color: white;
  box-shadow: 2px 5px 5px 1px lightgrey;
`
export const ImageContainer = styled.div`
  width: 100px;
  height: 100%;
  background-color: #eaecef;
  margin-right: 1%;
`
export const Image = styled.div`
  border: 1px solid white;
  width: 100%;
  height: 100%;
  background-color: #eaecef;
`

export const ContentContainer = styled.div`
  border: 1px solid white;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 5px 20px;
  justify-content: space-between;  
`

export const Stripe = styled.div`
  background-color: #eaecef;
  height: 20px;
  margin-bottom: 5px;
  animation: blinker 1.5s linear infinite;
  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }
`

export const SmallStripe = styled(Stripe)`
  width: 50%;
`
export const MediumStripe = styled(Stripe)`
  width: 70%;
`
export const LongStripe = styled(Stripe)`
  width: 100%;
`

// Modern Skeleton components with shimmer effect
export const SkeletonCard = styled.div`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1);
`;

export const SkeletonImage = styled.div`
  width: 100%;
  height: ${props => props.height || '200px'};
  background: linear-gradient(
    90deg,
    #F5F5F5 0%,
    #E5E5E5 50%,
    #F5F5F5 100%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
`;

export const SkeletonContent = styled.div`
  padding: 16px;
`;

export const SkeletonLine = styled.div`
  height: ${props => props.height || '16px'};
  width: ${props => props.width || '100%'};
  background: linear-gradient(
    90deg,
    #F5F5F5 0%,
    #E5E5E5 50%,
    #F5F5F5 100%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
  margin-bottom: ${props => props.noMargin ? '0' : '12px'};
`;

export const SkeletonCircle = styled.div`
  width: ${props => props.size || '48px'};
  height: ${props => props.size || '48px'};
  border-radius: 50%;
  background: linear-gradient(
    90deg,
    #F5F5F5 0%,
    #E5E5E5 50%,
    #F5F5F5 100%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
`;

// Venue Card Skeleton
export const VenueCardSkeleton = styled.div`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1);
`;

// Calendar Skeleton
export const CalendarSkeleton = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1);
`;

export const CalendarSkeletonHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const CalendarSkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
`;

export const CalendarSkeletonDay = styled.div`
  height: 60px;
  background: linear-gradient(
    90deg,
    #F5F5F5 0%,
    #E5E5E5 50%,
    #F5F5F5 100%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 8px;
`;

// Profile Skeleton
export const ProfileSkeleton = styled.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1);
`;

export const ProfileSkeletonHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #E5E5E5;
`;

export const ProfileSkeletonForm = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
